const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M15.47 5.78a.75.75 0 0 1 1.06-1.06l3.5 3.5a.747.747 0 0 1 0 1.06l-3.5 3.5a.75.75 0 1 1-1.06-1.06l2.22-2.22H9A3.75 3.75 0 0 0 9 17h5.5a.75.75 0 0 1 0 1.5H9A5.25 5.25 0 1 1 9 8h8.69z"/></svg>';
export {
  a as w
};
